import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaHeart, FaShieldAlt } from 'react-icons/fa';
import logo from '../../assets/diversity.png';
import '../../styles/components/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="footer-brand-mark"><img src={logo} alt="" /></span>
          <div><strong>MyCommunity</strong><p>Safer, simpler community living.</p></div>
        </div>
        <div className="footer-links" aria-label="Footer navigation">
          <NavLink to="/about" className="footer-link">About</NavLink>
          <NavLink to="/contact" className="footer-link">Contact</NavLink>
          <NavLink to="/privacy" className="footer-link">Privacy</NavLink>
          <NavLink to="/terms" className="footer-link">Terms</NavLink>
        </div>
        <div className="footer-trust"><FaShieldAlt /><span>Your community data stays protected</span></div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} MyCommunity Services</span>
        <span>Made with <FaHeart aria-label="care" /> for better neighbourhoods</span>
      </div>
    </footer>
  );
}

export default Footer;
